module.exports = __webpack_public_path__ + "img/yy-bg.6ff2d47a.png";